"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.linkToContactUs = void 0;
const index_1 = require("../index");
const linkToContactUs = (country, baseDomain, isFullPage) => {
    const locale = (0, index_1.getLang)();
    const part = locale === "ar" ? "مساعدة/اتصل-بنا" : "support/contact-us";
    if (window.location.href.includes("www.sooqtest.com")) {
        return `https://${isFullPage ? baseDomain.replace("sso.", "") : baseDomain}/${locale}/${part}`;
    }
    return `https://${!baseDomain.includes("shobiddak") ? country + "." : ""}${isFullPage ? baseDomain.replace("sso.", "") : baseDomain}/${locale}/${part}`;
};
exports.linkToContactUs = linkToContactUs;
